'use client';

import { VStack } from '@terra/ui-styled-system';
import { useTranslations } from 'next-intl';
import {
  TOOL_CALL_PROGRESS_ERROR_STAGE,
  type ToolCallProgressEvent,
} from '@terra/shared-dto-chat-types';
import { MonoSmall } from '../../../../components/typography';

type ToolCallProgressLogPanelProps = {
  progressEvents?: ToolCallProgressEvent[];
  isRunning?: boolean;
};

export function ToolCallProgressLogPanel({
  progressEvents,
  isRunning,
}: ToolCallProgressLogPanelProps) {
  const t = useTranslations('designSystem.chat.traceInvestigation');
  const events = progressEvents ?? [];

  if (events.length === 0) {
    return isRunning ? (
      <MonoSmall color="fg.muted">{t('waitingForUpdates')}</MonoSmall>
    ) : null;
  }

  return (
    <VStack gap="0" alignItems="stretch">
      {events.map((event) => (
        <MonoSmall
          key={event.id}
          color={
            event.stage === TOOL_CALL_PROGRESS_ERROR_STAGE
              ? 'fg.error'
              : 'fg.muted'
          }
          whiteSpace="pre-wrap"
          lineHeight="1.5"
        >
          {event.detail || event.stage}
        </MonoSmall>
      ))}
    </VStack>
  );
}
